export default __webpack_public_path__ + "static/media/background.b8257d81.png";